import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const SLEUTEL = 'nav:vorige-locatie';

/**
 * Onthoudt de laatste in-app-locatie met een ánder pad (pad + querystring),
 * zodat een Terug-knop zonder meegegeven herkomst (`state.from`) niet blind
 * naar de homepage springt, maar terug naar het scherm waar je vandaan kwam.
 * Tab-wissels binnen hetzelfde pad tellen niet: dan zou "Terug" op een
 * projectpagina alleen een projecttab teruggaan.
 */
export function useOnthoudVorigeLocatie() {
  const location = useLocation();
  const vorigeRef = useRef<{ pad: string; url: string } | null>(null);

  useEffect(() => {
    const url = location.pathname + location.search;
    const vorige = vorigeRef.current;
    if (vorige && vorige.pad !== location.pathname) {
      try {
        sessionStorage.setItem(SLEUTEL, JSON.stringify(vorige));
      } catch {
        /* opslag geblokkeerd — dan valt Terug terug op de standaard */
      }
    }
    vorigeRef.current = { pad: location.pathname, url };
  }, [location.pathname, location.search]);
}

/** De vorige in-app-locatie met een ander pad dan het huidige, of null. */
export function vorigeLocatie(): string | null {
  try {
    const ruw = sessionStorage.getItem(SLEUTEL);
    if (!ruw) return null;
    const vorige = JSON.parse(ruw) as { pad?: string; url?: string };
    if (!vorige.url || vorige.pad === window.location.pathname) return null;
    return vorige.url;
  } catch {
    return null;
  }
}
